import React, { Component } from "react";

class Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastPos: 25,
      selectedId: 0,
      isMoving: false,
      disabled: false,
      dataCount: 0
    };
  }

  allowScrolling = () => {
    document.body.style.overflow = "initial";
    document.body.style.touchAction = "initial";
    //document.body.classList.remove("no-scroll");
    // window.document.querySelector('.product-list-container').style.height =
    //   'initial';
    // window.document.querySelector('.product-list-container').style.overflow =
    //   'initial';
    // let body = window.document.querySelector('body');
    // body.style.display = 'initial';
    // body.style.height = body.offsetHeight;
    // body.style.overflow = 'initial';
    document.ontouchmove = function(e) {
      return true;
    };
  };

  disableScrolling = () => {
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";
    //document.body.classList.add("no-scroll");
    let list = window.document.querySelector(".product-list-container");
    list.style.cssText = `overflow:hidden; height:${
      list.offsetHeight
    }px; opacity:0.3`;

    document.ontouchmove = function(e) {
      e.preventDefault();
    };
  };

  onMoveStart = e => {
    if (this.state.disabled) return;
    this.disableScrolling();
    this.setState({ isMoving: true });
  };
  onMoveEnd = () => {
    this.allowScrolling();

    if (this.state.isMoving) {
      let holder = this.getRealPos("holder").top;
      let tag = this.getRealPos("tagName").top;
      let realNewPos = tag - holder - 4;

      this.setState(
        {
          isMoving: false,
          lastPos: realNewPos
        },
        () => {
          let list = window.document.querySelector(".product-list-container");
          list.style.cssText = undefined;
        }
      );
    }
  };

  getRealPos = ref => {
    let b = document.body.getBoundingClientRect();
    let r = this.refs[ref].getBoundingClientRect();
    return {
      top: r.top - b.top,
      left: r.left - b.left,
      bottom: r.bottom - b.bottom,
      right: r.right - b.right
    };
  };

  onClickSlider = e => {
    let newestPos = this.getPosition(e) - this.getRealPos("holder").top - 12.5;
    console.log(newestPos);
  };

  onMove = e => {
    const { isMoving } = this.state;
    if (isMoving) {
      let sliderGaugeSize = this.refs.sliderGauge.offsetHeight;
      let sliderOffset = this.refs.slider.offsetHeight;

      let newestPos =
        this.getPosition(e) - this.getRealPos("holder").top - 12.5;

      if (newestPos > 25 && newestPos < sliderOffset + sliderGaugeSize / 2) {
        let selectedId = Math.round(
          this.map(
            newestPos,
            25,
            sliderOffset + sliderGaugeSize / 2,
            0,
            this.props.data.length - 1
          )
        );

        this.setState({
          lastPos: newestPos,
          selectedId: selectedId
        });

        this.props.onChange(this.props.name, this.props.data[selectedId]);
        e.preventDefault();
        e.stopPropagation();
      }
    }
  };

  getPosition = e => {
    return e.touches && e.touches.length ? e.touches[0].pageY : e.pageY;
  };

  map = (num, in_min, in_max, out_min, out_max) => {
    return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
  };

  createLabels = (data, selected) => {
    let offset = 290;
    let fontSize = data.length > 30 ? "5px" : "10px";

    return data.map((label, index) => {
      return (
        <div
          className="holder-label"
          key={index}
          style={{
            top: `${this.map(index, 0, data.length - 1, 0, offset)}px`,
            fontSize: fontSize
          }}
        >
          {selected === index ? (
            <strong
              ref="tagName"
              style={{
                fontSize: `14px`,
                backgroundColor: "white",
                position: "relative",
                zIndex: 99
              }}
            >
              {label}
            </strong>
          ) : (
            label
          )}
        </div>
      );
    });
  };

  componentWillUpdate() {
    let { data, isMoving } = this.props;
    let { selectedId, disabled, lastPos, dataCount } = this.state;

    if (data.length <= 1 && selectedId > 1) {
      this.setState({ selectedId: 0, lastPos: 25, disabled: true }, () => {
        this.props.onChange(this.props.name, this.props.data[selectedId]);
      });
    } else if (data.length === 1 && disabled === false) {
      this.setState({ selectedId: 0, lastPos: 25, disabled: true }, () => {
        this.props.onChange(this.props.name, this.props.data[0]);
      });
    } else if (data.length > 1 && disabled === true) {
      this.setState({ disabled: false });
    } else if (
      !isMoving &&
      dataCount !== data.length &&
      data.length - 1 >= selectedId
    ) {
      let holder = this.getRealPos("holder").top;
      let tag = this.getRealPos("tagName").top;
      let realNewPos = tag - holder - 4;
      if (lastPos !== realNewPos)
        this.setState({ lastPos: realNewPos, dataCount: data.length });
    }
  }

  render() {
    let { data, unit } = this.props;
    let { selectedId, disabled } = this.state;

    return (
      <div
        className={`slider-bar` + (disabled ? " disabled" : "")}
        onMouseMove={this.onMove}
        onTouchMove={this.onMove}
        onMouseUp={this.onMoveEnd}
        onMouseLeave={this.onMoveEnd}
      >
        <div className="slider-holder" ref="holder">
          <span className="label">{this.props.label}</span>
          <div className="slider" onClick={this.onClickSlider}>
            <div
              name="slider-gauge"
              ref="sliderGauge"
              className="slider-gauge"
              style={{ top: `${this.state.lastPos}px` }}
              onMouseDown={this.onMoveStart}
              onTouchStart={this.onMoveStart}
              onMouseUp={this.onMoveEnd}
              onTouchEnd={this.onMoveEnd}
              /*onMouseOut={this.onMoveEnd}*/
            />
            <div className="slider-dot" ref="slider">
              {this.createLabels(data, selectedId)}
            </div>
          </div>
          <span className="unit">{unit}</span>
        </div>
      </div>
    );
  }
}

export default Slider;
// background: `linear-gradient(rgb(212, 212, 212) ${percentage}%,  ${percentage}%)`
//
